module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "blue-grey",
      "disabled": _vm.checkDisable
    },
    on: {
      "click": function($event) {
        return _vm.$refs.mediaUpload.click()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title ? _vm.title : 'Upload') + "\n    "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("\n      mdi-cloud-upload\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [(_vm.tmpImages.length > 0) ? _c('div', _vm._l((_vm.tmpImages), function(img, index) {
    return _c('v-col', {
      key: index,
      staticClass: "d-flex child-flex",
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "2",
        "lg": "2"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [_c('v-card', {
            staticClass: "d-flex",
            attrs: {
              "flat": "",
              "tile": "",
              "elevation": hover ? 16 : 2
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": img.url,
              "lazy-src": img.url,
              "aspect-ratio": "1"
            }
          }), _vm._v(" "), _c('v-overlay', {
            attrs: {
              "absolute": ""
            }
          }, [_c('v-btn', {
            attrs: {
              "dark": "",
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteImage(index)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "dark": "",
              "color": "red"
            }
          }, [_vm._v("cancel")])], 1)], 1)], 1)]
        }
      }], null, true)
    })], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.tmpFiles.length > 0) ? _c('v-row', _vm._l((_vm.tmpFiles), function(item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "2",
        "lg": "2",
        "align": "center"
      }
    }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/pdf.png",
        "aspect-ratio": "1"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/ppt.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/doc.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/text.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "dark": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "color": "red"
      }
    }, [_vm._v("cancel")])], 1)], 1)
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "media",
      "id": "fileToUpload",
      "accept": "image/*, .pdf, .ppt, .txt, .doc, .docx",
      "multiple": _vm.multiple || false
    },
    on: {
      "change": _vm.prepareUpload
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43c3718f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/custom/CustomFileUpload.vue
// module id = 2098
// module chunks = 0